import { Div } from '@codesuma/baseline'
import { SheetPage } from '../../components/sheet-page'
import { CONTACT_EMAIL } from '../../configs/app'
import style from './index.module.css'

// Privacy policy: Emrouz has no backend, accounts, or analytics — it states that
// plainly. Also serves as the in-app policy the app stores require.
export const PrivacyPage = () => {
    const base = SheetPage('حریم خصوصی')

    const paragraphs = [
        'امروز به حریم خصوصی شما احترام می‌گذارد.',
        'این برنامه هیچ داده‌ی شخصی‌ای جمع‌آوری، ذخیره یا ارسال نمی‌کند و از هیچ ابزار تحلیلی یا ردیابی استفاده نمی‌کند.',
        'همه‌ی تنظیمات شما تنها روی همین دستگاه نگهداری می‌شود و به هیچ سروری فرستاده نمی‌شود.',
        'اگر نمایش رویدادهای تقویم گوشی یا کارهای برنامه‌ی یادآورها را روشن کنید، برنامه آن‌ها را تنها روی همین دستگاه می‌خواند تا در تقویم نشان‌تان دهد. این‌ها نه ذخیره می‌شوند و نه به جایی فرستاده می‌شوند.',
        'رویدادهایی که خودتان در امروز می‌سازید روی همین دستگاه نگهداری می‌شوند. امروز چیزی در تقویم گوشی نمی‌نویسد.',
        'تقویم و رویدادهای ایران بدون اینترنت کار می‌کنند. برنامه تنها برای دو چیز به سرور ما وصل می‌شود: اصلاح‌های رؤیت هلال، و تعطیلات کشوری که خودتان اضافه کرده‌اید. هر دو فایل ثابت و همگانی‌اند و هیچ اطلاعاتی دربارهٔ شما همراه این درخواست‌ها فرستاده نمی‌شود.',
        `اگر پرسشی درباره‌ی حریم خصوصی دارید، با ما در ${CONTACT_EMAIL} در تماس باشید.`,
    ]

    for (const text of paragraphs) {
        const p = Div(text)
        p.addClass(style.para)
        base.append(p)
    }

    return base
}
